




























import { PartyCareProviderModel } from '@/libs/Api';
import { Guid } from '@/libs/common/functions/guid';
import Page from '@/Page.vue';
import { Component, Prop, Ref, VModel, Watch } from 'vue-property-decorator';

@Component({})
export default class CareProvidersList extends Page {

	newId = Guid.EmptyGuid();

    @Prop() tenantId!: string;
    @Prop() partyId!: string;
    @Prop() districtId!: string | null;
    @Prop({ default: false }) readonly!: boolean;
    @Prop({ default: null }) hide!: string | null;

    @VModel() careProviders!: PartyCareProviderModel[];

    @Watch("careProviders")
    careProvidersChanged (v: any, p: any) {
        console.log("careProvidersChanged", v, p);
    }

    get providerIds(): Array<string> {
        return this.careProviders.select(x => x.userId!).toArray();
    }

    private addClick () {
        const items = [...this.careProviders];
        items.push({
            id: Guid.EmptyGuid(),
            userId: Guid.EmptyGuid(),
            canProvideChargedTasks: false,
            canProvideFreeTasks: false,
            partyId: this.partyId,
        } as PartyCareProviderModel);
        this.$emit("input", items);
        this.onChanged();
    }

    private onChanged() {
        this.$emit("change");
    }

    public getProvidersList (): PartyCareProviderModel[] {
        const outItems: PartyCareProviderModel[] = [];
        const items = this.careProviders.filter(x => x.id != Guid.EmptyGuid() && x.userId != null && x.userId != Guid.EmptyGuid());
        const newItems = this.careProviders.filter(x => x.id == Guid.EmptyGuid() && x.userId != null && x.userId != Guid.EmptyGuid());
        items.forEach((x: PartyCareProviderModel) => {
            if (x.userId == null || x.userId == Guid.EmptyGuid())
                return;
            if (!outItems.find(e => e.userId == x.userId)) {
                outItems.push(x);
            }
        });
        newItems.forEach((x: PartyCareProviderModel) => {
            if (x.userId == null || x.userId == Guid.EmptyGuid())
                return;
            if (!outItems.find(e => e.userId == x.userId)) {
                outItems.push(x);
            }
        });
        return outItems;
    }

    private deleteItem (index: number) {
        this.careProviders.splice(index, 1);
    }

}
